/**
 * Copyright (C) 2020, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: BSAssetPreloadState.ts ,v 1.0 Exp $
 * Date Author Changes
 * 3 July 2020 Sujata Nethani Created
 *
 */
namespace States {
    /**
     * This state is used to load all assets for the game
     * All assets needed for the BaseGameState should be loaded with the Phaser.Loader using this.load or this.game.load, both referencing the LoadManager
     * All assets needed for other States should be loaded with the RuntimeLoader by using this.runtimeLoader
     * @class
     */
    export class BSAssetPreloadState extends GameAssetLoadState {
        public preload() {
            super.preload();
            //load soundsprite
            this.load.audiosprite("game", ["private/assets/sfx/BS.mp3", "private/assets/sfx/BS.m4a", "private/assets/sfx/BS.ogg", "private/assets/sfx/BS.ac3"], "private/assets/sfx/BS.json");
        }

        public create() {
            super.create();
            Sounds.SoundManager.addSprite('game');
        }

        /**
         * The preloadMobile method will be called on all mobile devices
         * it should be used to load all assets needed for mobile devices
         */
        public preloadMobile(): void {
            super.preloadMobile();
            this.load.atlasJSONHash('blsu_animation_gfx', 'private/assets/gfx/lr/basegame/BLSU_Animation_gfx.png', 'private/assets/gfx/lr/basegame/BLSU_Animation_gfx.json');
            this.load.atlasJSONHash('blsu_line_gfx', 'private/assets/gfx/lr/basegame/BLSU_Line_gfx.png', 'private/assets/gfx/lr/basegame/BLSU_Line_gfx.json');
            this.load.atlasJSONHash('blsu_reel_gfx', 'private/assets/gfx/lr/basegame/BLSU_Reel_gfx.png', 'private/assets/gfx/lr/basegame/BLSU_Reel_gfx.json');
            this.load.image('blsu_wp_hg', 'private/assets/gfx/lr/basegame/BLSU_WP_hg.png');
            this.load.image('bs_hg', 'private/assets/gfx/lr/basegame/BS_hg.png');
            this.load.image('merkursonne_hd', 'private/assets/gfx/lr/basegame/sun_logo.png');

            this.load.atlasJSONHash('background','private/assets/gfx/lr/basegame/portrait/BLSU_Background.png', 'private/assets/gfx/lr/basegame/portrait/BLSU_Background.json');
            this.load.atlasJSONHash('background_landscape','private/assets/gfx/lr/basegame/landscape/BLSU_Background.png', 'private/assets/gfx/lr/basegame/landscape/BLSU_Background.json');
            this.load.atlasJSONHash('reel_logo','private/assets/gfx/lr/basegame/BLSU_Reel_Logo.png', 'private/assets/gfx/lr/basegame/BLSU_Reel_Logo.json');
        }

        /**
         * The preloadDesktop method will be called on all desktop devices
         * it should be used to load all assets needed for desktops
         */
        public preloadDesktop(): void {
            super.preloadDesktop();
            this.load.atlasJSONHash('blsu_animation_gfx', 'private/assets/gfx/hr/basegame/BLSU_Animation_gfx.png', 'private/assets/gfx/hr/basegame/BLSU_Animation_gfx.json');
            this.load.atlasJSONHash('blsu_line_gfx', 'private/assets/gfx/hr/basegame/BLSU_Line_gfx.png', 'private/assets/gfx/hr/basegame/BLSU_Line_gfx.json');
            this.load.atlasJSONHash('blsu_reel_gfx', 'private/assets/gfx/hr/basegame/BLSU_Reel_gfx.png', 'private/assets/gfx/hr/basegame/BLSU_Reel_gfx.json');
            this.load.image('blsu_hg', 'private/assets/gfx/hr/basegame/BLSU_hg.png');
            this.load.image('blsu_wp_hg', 'private/assets/gfx/hr/basegame/BLSU_WP_hg.png');
            this.load.image('merkursonne_hd', 'private/assets/gfx/hr/basegame/merkursonne_HD.png');
        }

        /**
         * Creates a Sprite for each Image in the Cache
         * and renders them once, to create all GLTextures
         * since Phaser creates them when they are used for the first time, which can cause large frame times
         * e.g. uploading a 4096x4096 texture while the game is running
         * Its a good design choice to manually add the sprites to the Preloader Scene
         * that should be uploaded to the gpu, to reduce load times
         */
        protected prepareRenderer(): void {
            super.prepareRenderer();
        }
    }
}
